const tokenColors = {
  USDT: '#91B845',
  DAI: '#FFDE76',
  USD: '#FF6B6C',
  ETH: '#0497EC',
};

export default tokenColors;
